import React from "react";
import styled from "styled-components";
import Gauge from "../../charts/Gauge";

/**
 * Jauge semi-circulaire + valeur + sous-titre.
 * value : ReactNode (peut contenir un DeltaValue)
 */
const GaugeStat = ({ pct, color, tip, value, unit, sub, size }) => {
    return (
        <Wrapper>
            <div>
                <Gauge pct={pct} color={color} size={size} tip={tip} />
            </div>
            <div>
                <Value>
                    {value}
                    {unit && <Unit>{unit}</Unit>}
                </Value>
                {sub && <Sub>{sub}</Sub>}
            </div>
        </Wrapper>
    );
};

export default GaugeStat;

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

const Value = styled.div`
    font-size: var(--prh-font-kpi);
    font-weight: 600;
    color: var(--prh-ink);
`;

const Unit = styled.span`
    font-size: var(--prh-font-md);
    color: var(--prh-muted-2);
`;

const Sub = styled.div`
    font-size: 13px;
    color: var(--prh-muted-2);
`;
